<template>
    <div id="unavailable-link">
        <modal-box class="" :open="openModalBox" @close="openModalBox = false">
            <h2 class="mb-0" slot="header">{{ __('site.In-development') }}</h2>
            <div class="text-center mb-3" v-text=" __('site.Coming-soon')"></div>
            <div class="text-center" v-html=" __('site.Coming-soon-contact')"></div>
        </modal-box>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                openModalBox: false,
            }
        },

        mounted: function () {

            $('#app').on('click', '[data-unavailable]', ( event ) => {
                event.preventDefault();
                
                if ( ! this.openModalBox ) {
                    this.openModalBox = true;
                }

            });
        },
    }
</script>

<style lang="scss">
    @import "./../../sass/variables";

    #app [data-unavailable]{
        cursor: not-allowed !important;
    }

    #unavailable-link {

        .modal-box article{
            min-width: 17rem;
            max-width: 27rem;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/UnavailableLink.vue